export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full max-w-lg">
            <div className="relative aspect-[4/3] w-full rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20scene%20with%20large%20TV%20screen%20displaying%20cinematic%20content%2C%20soft%20ambient%20lighting%2C%20comfortable%20sofa%2C%20modern%20home%20entertainment%20setup%2C%20warm%20golden%20hour%20light%20through%20window%2C%20lifestyle%20photography&width=960&height=720&seq=bbtv-about-visual&orientation=landscape"
                alt="棒棒TV品牌理念 - 温馨观影体验"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
              关于我们
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-extrabold text-foreground-900 mb-4">
              让每个人都能轻松看好片
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              棒棒TV创立于对优质影视内容的执着追求。我们深知观众在寻找高清流畅观影体验时的种种烦恼
              ——广告弹窗、缓冲卡顿、资源不全。因此我们打造了这个专注于观影体验的平台，
              致力于用简洁干净的界面、高速稳定的播放技术和海量正版资源，让每一位观众都能沉浸在最纯粹的视听享受中。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              平台覆盖电视剧、电影、综艺、动漫等多种内容类型，每日同步更新最新剧集，
              并提供多线路切换与画质选择功能，确保在不同网络环境下都能获得最佳观看体验。
              棒棒TV，好内容值得被好好观看。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-3 px-4 py-2 rounded-lg bg-accent-50">
                <span className="text-2xl font-heading font-extrabold text-accent-500">500万+</span>
                <span className="text-xs text-foreground-500">日活用户</span>
              </div>
              <div className="flex items-center gap-3 px-4 py-2 rounded-lg bg-secondary-50">
                <span className="text-2xl font-heading font-extrabold text-secondary-500">10万+</span>
                <span className="text-xs text-foreground-500">影视资源</span>
              </div>
              <div className="flex items-center gap-3 px-4 py-2 rounded-lg bg-primary-50">
                <span className="text-2xl font-heading font-extrabold text-primary-500">99.8%</span>
                <span className="text-xs text-foreground-500">播放成功率</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}